module.exports = __webpack_public_path__ + "img/image36.2ea6ebf9.png";